﻿function setCaption(imageId) {
    const galleryId = $('[data-image-gallery-id]').data('image-gallery-id');
    $.get("/get-image-caption/" + imageId + "/" + galleryId, function (response) {
        //$('[data-slider-caption-container]').appendTo('.royalSlider');
        $('[data-slider-caption-container]').html(response);
        $('[data-slider-caption-container]').show();
    });
}

function updateUrl(event) {
    const history = window.History;
    const stateData = {};
    const imageId = event.target.currSlide.imageId || event.target.currSlide.caption?.prevObject.data('image-id');
    if (!imageId) {
        return;
    }
    setCaption(imageId);
    stateData.image = imageId;
    const queryString = $.param(stateData);
    stateData.doNotReloadAds = true;
    history.replaceState(stateData, $('title').html(), location.pathname + '?' + queryString);
}

function setupAdHolder(holder, type) {
    const ad = $('<div data-ad-holder>');
    const adHolderId = 'ad-' + type + '-' + (new Date()).getTime();
    ad.attr('id', adHolderId);
    holder.append(ad);
    return adHolderId;
}

function checkHolder(element, selector) {
    const holder = element.find(selector);
    const slot = holder.data('ad-slot');
    if (slot) {
        window.googletag.cmd.push(function () {
            window.googletag.pubads().refresh([slot]);
        });
        return null;
    }
    return holder;
}

function loadLeaderboard(slider) {
    const holder = checkHolder(slider, '.rsLeaderboardHolder');
    if (holder == null)
        return;
    const adHolderId = setupAdHolder(holder, 'leaderboard');

    initAd(slider, holder, adHolderId, [728, 90], 'leaderboard-1', [[[768, 0], [728, 90]], [[0, 0], [320, 50]]]);
}

function loadMpus(slider) {
    // we don't want to load or refresh MPUs on mobile
    if (window.isViewportLessThan('md')) {
        return;
    }

    // mpu 1
    let holder = checkHolder(slider, '.rsMpuHolder > .mpu-1-holder');
    let adHolderId;
    if (holder != null) {
        adHolderId = setupAdHolder(holder, 'mpu-1');

        initAd(slider, holder, adHolderId, [300, 250], 'mpu-1');
    }
    // mpu 2
    holder = checkHolder(slider, '.rsMpuHolder > .mpu-2-holder');
    if (holder != null) {
        adHolderId = setupAdHolder(holder, 'mpu-2');

        initAd(slider, holder, adHolderId, [300, 250], 'mpu-2');
    }
}

function loadSlideMpu(slider, slide) {
    $('[data-slider-caption-container]').hide();
    const existingSlot = slide.data('ad-slot');
    if (existingSlot) {
        window.googletag.cmd.push(function () {
            window.googletag.pubads().refresh([existingSlot]);
            disableNavigation(existingSlot);
        });
        return;
    }
    initAd(slider, slide, slide.find('[data-ad-container]').attr('id'), [300, 250], 'mpu-1', null, true);
}

function disableNavigation(slot) {
    slot.lockedNav = true;
    const slider = slot.slider;
    slider.slider.find('.rsOverflow').addClass('rsNoDrag');
    slider.slider.find('.rsArrow').hide();
    slider.st.navigateByClick = false;
    setTimeout(function () {
        unlock(slider);
    }, 5000);
}

function unlock(slider) {
    slider.slider.find('.rsOverflow').removeClass('rsNoDrag');
    slider.slider.find('.rsArrow').show();
    slider.st.navigateByClick = true;
}

function initAd(slider, holder, id, defaultSize, position, sizeMapping, disableNav) {
    window.googletag.cmd.push(function () {
        const thisPage = window.dfpAdsPage;
        const slotName = `${thisPage.slotName}/${position}`;
        let slot = window.googletag.defineSlot(slotName, defaultSize, id)
            .setTargeting('position', [position])
            .addService(window.googletag.pubads());
        if (sizeMapping)
            slot = slot.defineSizeMapping(sizeMapping);
        holder.data('ad-slot', slot);
        slot.slider = slider;

        // Display has to be called before
        // refresh and after the slot div is in the page.
        window.googletag.display(id);
        window.googletag.pubads().refresh([slot]);
        if (disableNav) {
            disableNavigation(slot);
        }
    });
}

function unlockNav(event) {
    const slot = event.slot;
    if (!slot.lockedNav)
        return;
    const slider = slot.slider;
    // unlock after a second and a half
    setTimeout(function () {
            slider.slider.find('.rsOverflow').removeClass('rsNoDrag');
            slider.slider.find('.rsArrow').show();
            slider.st.navigateByClick = true;
        },
        slider.st.adNavLockout);
}

function tryLoadMpu(event) {
    const slide = event.target.currSlide.content;
    if (slide.data('gallery-ad')) {
        loadSlideMpu(event.target, slide);
    }
}

function reloadFixedAds(event) {
    const $slider = event.target;

    $slider.leaderboardReloadCount += 1;
    if ($slider.leaderboardReloadCount >= $slider.st.leaderboardReloadAfter) {
        loadLeaderboard($slider.slider);
        $slider.leaderboardReloadCount = 0;
    }
    // don't increment the mpu count if it's not visible (i.e. it's on mobile)
    if (!window.isViewportLessThan('md')) {
        $slider.mpuReloadCount += 1;
        if ($slider.mpuReloadCount >= $slider.st.mpuReloadAfter) {
            loadMpus($slider.slider);
            $slider.mpuReloadCount = 0;
        }
    }
}

function postSlideChange(event) {
    const $slider = event.target;
    if (!$slider.slider.hasClass('rsFullscreen'))
        return;
    // manually turned off
    if ($slider.changeEventsDisabled) {
        return;
    }

    // this is for goto fast, after resize
    if ($slider.changeEventsDisabledByGoto) {
        // turn it off, as this is the animation complete off the gotoFast
        $slider.changeEventsDisabledByGoto = false;
        return;
    }

    reloadFixedAds(event);
    tryLoadMpu(event);
    updateUrl(event);


}

function setup() {

    window.loadGallery = function () {
        const sliders = $("[data-slider-gallery]");
        if (sliders.length === 0)
            return;

        sliders.each(function (index, element) {
            const $element = $(element);
            if ($element.data('royalSlider') != null)
                return;

            const slides = $element.children().clone();
            const desktopSlides = slides.filter('a').clone();

            const options = {
                arrowsNavAutoHide: false,
                imageScaleMode: 'fit-if-smaller',
                imageScalePadding: 0,
                controlNavigationSpacing: 0,
                controlNavigation: "none",
                loop: true,
                numImagesToPreload: 1,
                keyboardNavEnabled: true,
                usePreloader: true,
                slidesSpacing: 0,
                minSlideOffset: 0,
                leaderboardReloadAfter: $element.data('leaderboard-reload-after') || 4,
                mpuReloadAfter: $element.data('mpu-reload-after') || 4,
                adNavLockout: $element.data('ad-nav-lockout') || 1500,
                fullscreen: {
                    // fullscreen options go here
                    enabled: true,
                    nativeFS: false
                }
            };
            $element.royalSlider(options);
            const slider = $element.data('royalSlider');


            const mpuHolder = $('<div class="rsMpuHolder">');
            const mpu1 = $('<div class="mpu-1-holder mb-3">').appendTo(mpuHolder);
            const mpu2 = $('<div class="mpu-2-holder mb-3">').appendTo(mpuHolder);
            $element.prepend(mpuHolder);
            const leaderboardHolder = $('<div class="rsLeaderboardHolder">').prependTo($element);

            slider.ev.on('rsExitFullscreen', function () {
                // exit fullscreen mode
                $('#heading-group').css('z-index', '2');
                $element.hide();
                $element.removeClass("fullscreen");
            });
            slider.ev.on('rsBeforeSizeSet', function () {
                // adjust the fullsize height of the wrapper to not include the leaderboard and mpu holders
                const leaderboardHolderHeight = leaderboardHolder.outerHeight(true);
                const mpuHolderWidth = mpuHolder.outerWidth(true);
                slider._wrapHeight = slider._wrapHeight - leaderboardHolderHeight;
                slider._wrapWidth = slider._wrapWidth - mpuHolderWidth;
            });

            // do not display on initial load
            $element.hide();


            slider.allSlides = jQuery.extend(true, [], slider.slides);
            slider.desktopSlides = $(slider.allSlides).filter(function (index, element) {
                return element.images !== null
            }).get();

            function goToFast(indexOf) {
                slider.changeEventsDisabledByGoto = true;
                const temp = slider.st.transitionSpeed;
                slider.st.transitionSpeed = 0;
                slider.goTo(indexOf, true);
                slider.st.transitionSpeed = temp;
            }

            function setToDesktop(init) {
                slider.changeEventsDisabled = true;
                // ensure not on advert
                // if the index is of an advert, we look for the id below, as the first slide can never be an ad
                if (slider.currSlide.images == null) {
                    slider.goTo(slider.currSlideId - 1, true);
                }
                const indexOf = slider.desktopSlides.findIndex(function (element) {
                    return element.images[0] === slider.currSlide.images[0];
                });
                while (slider.slides.length > 0) {
                    slider.removeSlide(0);
                }
                for (let i = 0; i < slider.desktopSlides.length; i++) {
                    const slide = desktopSlides[i];
                    slider.appendSlide(slide);
                }

                setTimeout(function () {
                    goToFast(indexOf);
                }, 50);
                slider.changeEventsDisabled = false;
            }

            function setToMobile() {
                slider.changeEventsDisabled = true;
                const indexOf = slider.allSlides.findIndex(function (element) {
                    return element.images != null && element.images[0] === slider.currSlide.images[0];
                });
                while (slider.slides.length > 0) {
                    slider.removeSlide(0);
                }
                for (let i = 0; i < slider.allSlides.length; i++) {
                    const slide = slides[i];
                    slider.appendSlide(slide);
                }

                setTimeout(function () {
                        goToFast(indexOf);
                    },
                    50);
                slider.changeEventsDisabled = false;
            }

            // by default the slides are for mobile as they include ads inbetween, so we'll move to desktop if it's not that

            $(document).on('viewport-changed',
                function (event, data) {
                    // do nothing if the change is non-mobile related
                    if (data.from !== document.viewportSize.mobile && data.to !== document.viewportSize.mobile) {
                        return;
                    }

                    //var indexOf;
                    if (data.to === document.viewportSize.mobile) {
                        setToMobile();
                    } else if (data.from === document.viewportSize.mobile) {
                        setToDesktop();
                    }
                    loadLeaderboard($element);
                    loadMpus($element);
                    // reset this if it's been force reloaded
                    slider.leaderboardReloadCount = 0;
                });

            slider.ev.on('rsEnterFullscreen', function () {
                // enter fullscreen mode
                $('#heading-group').css('z-index', '1');
                $element.show();
                $element.addClass("fullscreen");
                const defaultImageId = $('[data-default-image-id]').data('default-image-id');
                setCaption(defaultImageId);
                loadLeaderboard($element);
                loadMpus($element);

                if (!window.isViewportLessThan('md')) {
                    setToDesktop();
                } else {
                    setToMobile();

                }
            });

            // add ad reload variables
            slider.leaderboardReloadCount = 0;
            slider.mpuReloadCount = 0;

            slider.ev.on('rsAfterSlideChange', postSlideChange);

            window.gallerySliderData = slider;
            const siblings = $element.siblings('[data-slider-caption-container]');
            const caption = $element.find('.rsGCaption');
            caption.appendTo(siblings);
        });
    };
}

function launchGallery(event) {
    event.preventDefault();
    const $this = $(event.currentTarget)
    const galleryName = $this.closest('.article-gallery').find('[data-slider-gallery]').data('slider-gallery');
    const gallery = $('[data-slider-gallery="' + galleryName + '"]');
    const slider = gallery.data('royalSlider');
    if (!slider)
        return;
    const index = $this.data('gallery-launcher-index');
    if (typeof index == "undefined")
        return;
    const slide = $(slider.allSlides).filter(function (_, element) {
        return element.id === index
    }).get(0);
    if (slide == null)
        return;
    const slideIndex = slider.slides.findIndex(function (element) {
        return element.images != null && element.images[0] === slide.images[0];
    });
    if (slideIndex === -1)
        return;
    slider.goTo(slideIndex, false);
    setTimeout(function () {
            slider.enterFullscreen();
        },
        51);
}

export function setupGallery() {
    setup();
    window.loadGallery();
    $(document).on('click', '[data-gallery-launcher]', launchGallery);

    if (window.googletag)
        window.googletag.pubads().addEventListener('slotOnload', unlockNav);
}
